import * as React from 'react';
import { connect } from 'react-redux';
import store from '../store/store';
import types from '../store/types';
import { IControlBlock, EModalType, PropertyHelper, IOutputValue, OutputsHelper, OutputReferenceHelper, ModalHelper } from '../helpers';
import { IDropdownOption } from 'office-ui-fabric-react';
import { ControlBlockConfig } from '../components';

class ControlBlockConfigContainer extends React.Component<any, any> {

    updateProperty = (key: string, value: any) => {

        let { controlBlock } = this.props.state;

        if(key === 'Is Repeatable') {
            let repeatableGroupName = PropertyHelper.getProperty(controlBlock.Properties, 'Repeatable Group Name');
            if(value) {
                repeatableGroupName.IsRequired = true;
            }
            else {
                repeatableGroupName.IsRequired = false;
            }
        }

        controlBlock = PropertyHelper.updateProperty(controlBlock, key, value);

        store.dispatch({
            type: types.UPDATE_CONTROL_BLOCK_DIALOG,
            controlBlock: controlBlock
        });

    }

    closeDialog = (save?: boolean) => {

        let { state } = this.props;

        if(save) {

            let errorMessages: string[] = PropertyHelper.getErrorMessages(state.controlBlock.Properties, false, false);

            if(!errorMessages.length) {
                //if a block is not repeatable then fix Max Iterations to null
                let isRepeatable = PropertyHelper.getPropertyValue(state.controlBlock.Properties, 'Is Repeatable');
                if(!isRepeatable) {
                    PropertyHelper.updateProperty(state.controlBlock, 'Number Of Iterations', JSON.stringify({text: '', markup: '<p></p>'}));
                    PropertyHelper.updateProperty(state.controlBlock, 'Max Iterations', null);
                }

                store.dispatch({
                    type: types.UPDATE_CONTROL_BLOCK,
                    controlBlock: state.controlBlock
                });

                store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
            }
            else {

                store.dispatch({
					type: types.SET_MODAL_ERROR_MESSAGES,
					errorMessages: errorMessages
				});

				//scroll to the top of the dialog so that the error message is visible
                ModalHelper.scrollToErrorDisplay();

            }

        }
        else {
            store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
        }

    }

    public render() {
        
        let { state, outputs } = this.props;

        let dropdownOptions:IDropdownOption[] = OutputsHelper.getOutputDropdownOptions(outputs, state.previousOutputBlocks);
        
        return <ControlBlockConfig 
            allOutputReferences={ state.allOutputReferences }
            closeDialog={ this.closeDialog }
            controlBlock={ state.controlBlock }
            updateProperty={ this.updateProperty }
            outputOptions={ dropdownOptions }
        />;
    }

}

const mapStateToProps = (store) => {

    let outputs: IOutputValue[] = OutputsHelper.combineOutputs(store.outputsState.outputs, store.outputsState.globalOutputs, store.modalState.modal.parentLoopId);

    return {
        state: store.modalState.controlBlockConfig,
        outputs: outputs
    };

};

export default connect<any, any, any>(mapStateToProps)(ControlBlockConfigContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/control-block-config.tsx